// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentTcsWrapperModelsAccumulatorModel {
    static getAttributeTypeMap() {
        return EnrollmentTcsWrapperModelsAccumulatorModel.attributeTypeMap;
    }
}
EnrollmentTcsWrapperModelsAccumulatorModel.discriminator = undefined;
EnrollmentTcsWrapperModelsAccumulatorModel.additionalProperties = false;
EnrollmentTcsWrapperModelsAccumulatorModel.attributeTypeMap = [
    {
        "name": "medications",
        "baseName": "medications",
        "type": ""
    },
    {
        "name": "medicationMaxBenefit",
        "baseName": "medicationMaxBenefit",
        "type": "number"
    },
    {
        "name": "remainingMedicationBenefit",
        "baseName": "remainingMedicationBenefit",
        "type": "number"
    },
    {
        "name": "totalMedicationPaid",
        "baseName": "totalMedicationPaid",
        "type": "number"
    },
];
//# sourceMappingURL=enrollmentTcsWrapperModelsAccumulatorModel.js.map